import { render, staticRenderFns } from "./WaterBalanceIwa.vue?vue&type=template&id=45515c9e&scoped=true&"
import script from "./WaterBalanceIwa.vue?vue&type=script&lang=js&"
export * from "./WaterBalanceIwa.vue?vue&type=script&lang=js&"
import style0 from "./WaterBalanceIwa.vue?vue&type=style&index=0&id=45515c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45515c9e",
  null
  
)

export default component.exports